import { combineReducers } from "redux";
import accountTransactions, { type AccountTransactionsState } from "./accountTransactions";
import app, { type AppState } from "./app";
import bankAccounts, { type BankAccountsState } from "./bankAccounts";
import countries, { type CountryState } from "./countries";
import customer, { type CustomerState } from "./customer";
import documents, { type DokumentState } from "./documents";
import error from "./error";
import flyt, { type FlytState } from "./flyt/flytReducer";
import flyttPkb from "./flyttPkb";
import fondsskole, { type FondsskoleState } from "./fondsskole";
import fundSwitch from "./fundSwitch";
import holdingsHistory from "./holdingsHistory";
import withInit from "./init";
import investmentPrograms, { type InvestmentPrograms } from "./investmentPrograms";
import kartlegging, { type KartleggingState } from "./kartlegging";
import log from "./log";
import metadata, { type MetadataState } from "./metadata";
import njordUtbetalingsoversikt from "./njordUtbetalingsoversikt";
import norskPensjon from "./norskPensjon";
import type { NorskPensjon } from "./norskPensjon/norskPensjonReducer";
import policies, { type PoliciesState } from "./policies";
import prices, { type PricesState } from "./prices";
import prognosis from "./prognosis";
import samtykke, { type SamtykkeState } from "./samtykke";
import sl from "./sl";
import uiState from "./uiState";
import utbetalingsoversikt from "./utbetalingsoversikt";
import type { Utbetalingsoversikt } from "../selectors";
import type { EPK } from "~/flytt-sl/felles/hooks/useFlyttEpk";

export interface State {
	accountTransactions: AccountTransactionsState;
	app: AppState;
	bankAccounts: BankAccountsState;
	countries: CountryState;
	customer: CustomerState;
	customerSupport;
	documents: DokumentState;
	error;
	fondsskole: FondsskoleState;
	fundSwitch;
	holdingsHistory;
	investmentPrograms: InvestmentPrograms;
	log;
	metadata: MetadataState;
	njordUtbetalingsoversikt;
	norskPensjon: NorskPensjon;
	policies: PoliciesState;
	prognosis;
	samtykke: SamtykkeState;
	sl: EPK;
	flyttPkb;
	uiState;
	utbetalingsoversikt: Utbetalingsoversikt[];
	prices: PricesState;
	kartlegging: KartleggingState;
	flyt: FlytState;
}

const reducers = combineReducers({
	accountTransactions,
	app,
	bankAccounts,
	countries,
	customer,
	documents,
	error,
	fondsskole,
	fundSwitch,
	holdingsHistory,
	investmentPrograms,
	log,
	metadata,
	njordUtbetalingsoversikt,
	norskPensjon,
	policies,
	prognosis,
	samtykke,
	sl,
	flyttPkb,
	uiState,
	utbetalingsoversikt,
	prices,
	kartlegging,
	flyt,
});

export default withInit(reducers);
